import * as Turbo from "@hotwired/turbo"
Turbo.start()

// Stimulus
import { application } from "../controllers/application"
import "../controllers"

// HakumiComponents (npm package)
import HakumiComponents, { registerHakumiControllers } from "@hakumi-dev/hakumi-components"

window.HakumiComponents = HakumiComponents
registerHakumiControllers(application)

// styles
import "../stylesheets/application.scss"
import "prismjs/themes/prism.css"
